import { ObservedAccountState, UNKNOWN } from "./testAccountHealth.types"

export const diffStateSamples = (
  a: ObservedAccountState,
  b: ObservedAccountState,
): string[] =>
  (Object.keys(a) as Array<keyof ObservedAccountState>)
    .filter(
      (key) => a[key] !== UNKNOWN && b[key] !== UNKNOWN && a[key] !== b[key],
    )
    .map(String)
    .sort()
